import { TFunction } from '@lyearn/i18n';
import { NucleoFlag } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { ActionItemPriorityEnum } from '@/types/schema';

interface ActionItemPriorityType {
  value: ActionItemPriorityEnum;
  labelKey: string;
  Icon: typeof NucleoFlag;
  color: string;
}

export const ACTION_ITEM_PRIORITY_CONFIG: Record<ActionItemPriorityEnum, ActionItemPriorityType> = {
  [ActionItemPriorityEnum.NoPriority]: {
    value: ActionItemPriorityEnum.NoPriority,
    labelKey: 'Task:Filter.NoPriority',
    Icon: (props) => <NucleoFlag {...props} fill="#BFBFBF" secondaryFillOpacity={0} />,
    color: '#BFBFBF',
  },
  [ActionItemPriorityEnum.Low]: {
    value: ActionItemPriorityEnum.Low,
    labelKey: 'Task:Filter.Low',
    Icon: (props) => <NucleoFlag {...props} fill="#BFBFBF" />,
    color: '#BFBFBF',
  },
  [ActionItemPriorityEnum.Medium]: {
    value: ActionItemPriorityEnum.Medium,
    labelKey: 'Task:Filter.Medium',
    Icon: (props) => <NucleoFlag {...props} fill="#0065FF" />,
    color: '#0065FF',
  },
  [ActionItemPriorityEnum.High]: {
    value: ActionItemPriorityEnum.High,
    labelKey: 'Task:Filter.High',
    Icon: (props) => <NucleoFlag {...props} fill="#F59E0B" />,
    color: '#F59E0B',
  },
  [ActionItemPriorityEnum.Urgent]: {
    value: ActionItemPriorityEnum.Urgent,
    labelKey: 'Task:Filter.Urgent',
    Icon: (props) => <NucleoFlag {...props} fill="#DC2626" />,
    color: '#DC2626',
  },
};

export const getActionItemPriorityMenuItems = (t: TFunction) => {
  return Object.values(ACTION_ITEM_PRIORITY_CONFIG).map((config) => ({
    id: config.value,
    StartIcon: config.Icon,
    label: t(config.labelKey),
  })) satisfies ActionMenuItemType[];
};
